<script>
    export default {
        props: ['items', 'initItem'],
        data() {
            return {
                selectedItem: this.initItem,
            }
        },
        mounted() {
            let vm = this;
            this.$nextTick(() => {
console.log(1);

                $('.timeline.owl-carousel').owlCarousel({
                    loop: true,
                    items: 5,
                    autoplayHoverPause: true,
                    autoplay: true,
                    autoplayTimeout: 1000000,
                    smartSpeed: 900,
                    nav: true,
                    dots: false,
                    center: true,
                    navText: [
                        '<i class="fas fa-chevron-left"></i>',
                        '<i class="fas fa-chevron-right"></i>'
                    ],
                    responsiveClass:true,
                    responsive:{
                        0:{
                            items: 1
                        },
                        576:{
                            items: 3
                        },
                        991:{
                            items: 5
                        }
                    },
                    onInitialized: function() {
                        $('.timeline .owl-prev').attr('tabindex', -1);
                        $('.timeline .owl-next').attr('tabindex', -1);
                    }
                }).on('changed.owl.carousel',function(element){
                    var current = element.item.index;
                    vm.selectedItem = $(element.target).find(".owl-item").eq(current).find(".item").attr("data-id");
                });
            });


        }
    }
</script>
